import { getTheme } from "@clipboard-health/ui-theme";
import { isDefined } from "@clipboard-health/util-ts";
import { ThemeProvider } from "@mui/material";

import { ModalRoute } from "../../redesign/Navigation/ModalRoute";
import { ModalTransitionSwitch } from "../../redesign/Navigation/ModalTransitionSwitch";
import { EarningsInfoBottomSheet } from "./components/ReferralStats/EarningsInfoBottomSheet";
import { ShareReferralLinkBottomSheet } from "./components/ShareReferralLink/ShareReferralLinkBottomSheet";
import { EARNINGS_INFO_PATH, INVITE_WORKPLACE_PATH } from "./paths";

interface WorkplaceReferralsModalRoutesProps {
  basePath: string;
}

export function WorkplaceReferralsModalRoutes(props: WorkplaceReferralsModalRoutesProps) {
  const { basePath } = props;

  return (
    <ThemeProvider theme={getTheme()}>
      <ModalTransitionSwitch>
        <ModalRoute
          path={`${basePath}/${EARNINGS_INFO_PATH}`}
          render={({ modalState }) => {
            return <EarningsInfoBottomSheet modalState={modalState} />;
          }}
        />
        <ModalRoute
          path={`${basePath}/${INVITE_WORKPLACE_PATH}`}
          render={({ modalState, location }) => {
            const queryParams = new URLSearchParams(location?.search ?? "");
            const referralCode = queryParams.get("referralCode");
            if (!isDefined(referralCode)) {
              return null;
            }

            return (
              <ShareReferralLinkBottomSheet modalState={modalState} referralCode={referralCode} />
            );
          }}
        />
      </ModalTransitionSwitch>
    </ThemeProvider>
  );
}
